/*
 * Forwards aw.fyi "buy again" re-order tracking from URL into Shopify
 * line-item properties on the Add-to-Cart form.
 *
 * When the variant-change button on aw.fyi sends a customer to a Shopify
 * product page with `?reference_garment=<barcode>` (and optionally
 * `?reference_inquiry=<uuid>`), AW needs that reference to ride along to the
 * resulting Shopify order so order_import can recognize it as a re-order.
 *
 * Strategy:
 *   1. On load, read reference_garment / reference_inquiry from the URL.
 *      Fall back to sessionStorage so the reference survives storefront
 *      navigation in the same tab. Persist whatever we find.
 *   2. Inject hidden `properties[_reference_garment]` (and `_reference_inquiry`)
 *      inputs into every Add-to-Cart form on initial DOM ready.
 *   3. Also re-inject on the `submit` event in capture phase. Themes that
 *      replace the form node on variant change (Section Rendering API, AJAX
 *      product blocks) would otherwise wipe the inputs; the capture-phase
 *      listener on document runs before the theme's own submit handler, so
 *      we re-inject just in time.
 *
 * Theme compatibility note: this relies on the theme building the cart/add
 * request from `new FormData(form)` (so hidden inputs are picked up
 * automatically). Venue does — see product-form.js. Themes that construct
 * the request body manually from named inputs would silently drop these.
 */
(function () {
  if (window.__awReferenceGarment) return;
  window.__awReferenceGarment = true;

  var FORM_SELECTOR = 'form[action*="/cart/add"]';

  function readRef() {
    var params = new URLSearchParams(window.location.search);
    var refGarment = params.get('reference_garment') || sessionStorage.getItem('aw_reference_garment') || '';
    var refInquiry = params.get('reference_inquiry') || sessionStorage.getItem('aw_reference_inquiry') || '';
    if (refGarment) sessionStorage.setItem('aw_reference_garment', refGarment);
    if (refInquiry) sessionStorage.setItem('aw_reference_inquiry', refInquiry);
    return { garment: refGarment, inquiry: refInquiry };
  }

  function ensureInput(form, name, value) {
    if (!value) return;
    if (form.querySelector('input[name="' + name + '"]')) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  function injectInto(form) {
    var ref = readRef();
    if (!ref.garment && !ref.inquiry) return;
    ensureInput(form, 'properties[_reference_garment]', ref.garment);
    ensureInput(form, 'properties[_reference_inquiry]', ref.inquiry);
  }

  function injectAll() {
    document.querySelectorAll(FORM_SELECTOR).forEach(injectInto);
  }

  // Read once at script load so sessionStorage is seeded even before
  // DOMContentLoaded (e.g. if the customer navigates away before then).
  readRef();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectAll);
  } else {
    injectAll();
  }

  // Capture phase: runs before the theme's own bubble-phase submit handler,
  // so we re-inject even if the form was just re-rendered (Section Rendering
  // API, variant-switch re-paint, quick-shop modal, etc.).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.matches && form.matches(FORM_SELECTOR)) {
      injectInto(form);
    }
  }, true);
})();
